export default {
  getCampaignList: {
    url: '/operationads/wish/campaign/report',
    method: 'post',
    desc: '广告报表-活动列表查询'
  },
  getProductStatusList: {
    url: '/product/wish/check/product/status',
    method: 'post',
    desc: '广告报表-新建活动-商品是否过期'
  },
  getProductSummaryList: {
    url: '/operationads/wish/product/report/summary',
    method: 'post',
    desc: '广告报表-商品列表查询'
  },
  getSynchronousList: {
    url: '/operationads/wish/campaign/synchronous/list',
    method: 'post',
    desc: '广告报表-手动同步查询'
  },
  synchronous: {
    url: '/operationads/wish/campaign/synchronous',
    method: 'post',
    desc: '广告报表-手动同步'
  },
  campaignAdd: {
    url: '/operationads/wish/campaign/add',
    method: 'post',
    desc: '新增广告活动'
  },
  campaignModify: {
    url: '/operationads/wish/campaign/modify',
    method: 'post',
    desc: '编辑广告活动'
  },
  budgetBreakdown: {
    url: '/operationads/wish/campaign/budget/breakdown ',
    method: 'post',
    desc: '新建广告-钱包余额'
  },
  getProductList: {
    url: '/product/wish/list',
    method: 'post',
    desc: 'wish商品查询'
  },
  getProductAnalyse: {
    url: '/operationads/wish/product/report/analyse',
    method: 'post',
    desc: '分析查询列表'
  },
  getShopReportList: {
    url: '/operationads/wish/report/shop',
    method: 'post',
    desc: '店铺报表-表格列表查询'
  },
  getProductReportList: {
    url: '/operationads/wish/report/product',
    method: 'post',
    desc: '店铺报表-表格列表查询'
  },
}
